<template>
  
  <ul class="con-s w-full mb-2">
    <li>
      <vs-switch
        @input="$emit('input', $event)"
        :disabled="isDisabled" class="mt-2" :value="value" />
    </li>
  </ul>
</template>
  <!-- @input="onFieldChange($event, field)" -->

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
  },
  watch: {

  },
  data() {
    return {
      text: ''
    };
  },
  methods: {
    handleFocusOut() {
      this.$emit("onTextFieldFocusOut");
    },
    handleClick() {
      this.$emit("onTextFieldClick");
    }
  }
};
</script>

<style scoped>
/* Add component-specific styles here */
</style>
